import { TOptimizelyCustomWindow } from './types';

export function isOptimizelyLoaded(
    window: any
): window is TOptimizelyCustomWindow {
    if (
        window['optimizely'] === undefined ||
        typeof window.optimizely !== 'object'
    ) {
        return false;
    }

    return true;
}
